// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__Wsetp","topLabel":"styles_topLabel__tMUWP","topLabelVal":"styles_topLabelVal__+BsJD","tableContainer":"styles_tableContainer__SALd9"};